import type { IconSvgObject } from './types';

const UserPlusIcon: IconSvgObject = [
  ["path", { d: "M13 13.5028C11.9287 13.1795 10.7448 13 9.5 13C7.72212 13 6.0685 13.3661 4.68968 13.9946C3.55927 14.5099 3 15.7281 3 16.9704V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "9.5", cy: "6.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 21L17.5 14M14 17.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserPlusIcon;
